import { CompanyDomainModel } from '../domainModels/company-domain-model';
import { DisplayAttributesDomainModel } from '../domainModels/display-attributes-domain-model';
import { DisplayDomainModel } from '../domainModels/display-domain-model';
import { HelpDomainModel } from '../domainModels/help-domain-model';
import { LocationDomainModel } from '../domainModels/location-domain-model';
import { MenuDomainModel } from '../domainModels/menu-domain-model';
import { PexelsDomainModel } from '../domainModels/pexels-domain-model';
import { ProductDomainModel } from '../domainModels/product-domain-model';
import { ScheduledMenusDomainModel } from '../domainModels/scheduled-menus-domain-model';
import { SmartFiltersDomainModel } from '../domainModels/smart-filters-domain-model';
import { FilterProductsFormViewModel } from '../views/shared/components/filter-products-form/filter-products-form-view-model';
import { AllProductsViewModel } from '../views/product/viewModels/all-products-view-model';
import { AllProductsDataTableViewModel } from '../views/tables/all-products-data-table/all-products-data-table-view-model';
import { DigitalMarketingMenusViewModel } from '../views/menu/components/menus/digital/digital-marketing-menus/digital-marketing-menus-view-model';
import { OrderReceivingFilterFormViewModel } from '../views/product/components/order-receiving/order-receiving-filter-form/order-receiving-filter-form-view-model';
import { SyncSmartFilterService } from '../services/smart-filter-sync.service';
import { ProductPickerDataTableViewModel } from '../views/tables/product-picker-data-table/product-picker-data-table-view-model';
import { ProductPickerViewModel } from '../views/product/viewModels/product-picker-view-model';
import { SmartFilterRowViewModel } from '../views/smart-filters/components/smart-filter-card-row/smart-filter-row-view-model';
import { OrderReceivingViewModel } from '../views/product/components/order-receiving/order-receiving-view-model';
import { ShowInventorySinceViewModel } from '../views/product/components/order-receiving/order-receiving-time-and-property-selection/show-inventory-since/show-inventory-since-view-model';
import { SelectBulkChangePropertiesViewModel } from '../views/product/components/order-receiving/order-receiving-time-and-property-selection/select-bulk-change-properties/select-bulk-change-properties-view-model';
import { WebMenusContainerViewModel } from '../views/menu/components/menus/web/web-menus-container/web-menus-container-view-model';
import { PrintMenusContainerViewModel } from '../views/menu/components/menus/print/print-menus-container/print-menus-container-view-model';
import { DigitalMenusContainerViewModel } from '../views/menu/components/menus/digital/digital-menus-container/digital-menus-container-view-model';
import { AllDisplaysViewModel } from '../views/display/viewModels/all-displays-view-model';
import { TypeService } from '../services/type-service';
import { SyncDomainModel } from '../domainModels/sync-domain-model';
import { TemplateDomainModel } from '../domainModels/template-domain-model';
import { TemplateCollectionDomainModel } from '../domainModels/template-collection-domain-model';
import { DigitalTemplatesContainerViewModel } from '../views/template/components/templates/digital/digital-templates-container/digital-templates-container-view-model';
import { PrintTemplatesContainerViewModel } from '../views/template/components/templates/print/print-templates-container/print-templates-container-view-model';
import { WebTemplatesContainerViewModel } from '../views/template/components/templates/web/web-templates-container/web-templates-container-view-model';
import { SectionBlueprintsDomainModel } from '../domainModels/section-blueprints-domain-model';
import { DomainTunnelFromMenuToTemplateService } from '../services/domain-tunnel-from-menu-to-template.service';
import { MenuPreviewService } from '../services/menu-preview.service';
import { PrintPDFService } from '../services/print-pdf.service';
import { ChangesRequiredForPreviewService } from '../services/changes-required-for-preview.service';
import { MenuDisplayableSubItemService } from '../views/shared/components/displayable-content/displayable-item-container/displayable-item-preview/menu-displayable-sub-item.service';
import { LabelDomainModel } from '../domainModels/label-domain-model';
import { BadgeDomainModel } from '../domainModels/badge-domain-model';
import { PrintCardPreviewService } from '../services/print-card-preview.service';
import { BulkPrintJobDomainModel } from '../domainModels/bulk-print-job-domain-model';
import { DeviceDomainModel } from '../domainModels/device-domain-model';
import { CannabinoidsAndTerpenesDomainModel } from '../domainModels/cannabinoids-and-terpenes-domain-model';
import { WebSocketService } from '../services/web-socket.service';
import { ProductApi } from '../api/product-api';
import { DisplayApi } from '../api/display-api';
import { TemplateApi } from '../api/template-api';
import { AppOutOfDateService } from '../services/app-out-of-date.service';
import { MenuApi } from '../api/menu-api';
import { AutomationApi } from '../api/automation-api';
import { ProductTagDomainModel } from '../domainModels/product-tag-domain-model';
import { RestrictedLocationMismatchService } from '../services/restricted-location-mismatch.service';
import { BadgeMappingDomainModel } from '../domainModels/badge-mapping-domain-model';
import { FileSystemService } from '../services/file-system.service';
import { AssetService } from '../services/asset.service';
import { PrivateFileSystemAssetService, PrivateFileSystemService } from '@mobilefirstdev/private-file-storage';
import { FiltersDomainModel } from '../domainModels/filters-domain-model';
import { HighGuideInsightsDomainModel } from '../domainModels/high-guide-insights-domain-model';
import { HighGuideInsightsPlaceholderService } from '../services/high-guide-insights-placeholder.service';
import { ProductSignalsDomainModel } from '../domainModels/product-signals-domain-model';
import { GuideApi } from '../api/guide-api';
import { PreviewWaitingPoolService } from '../services/preview-waiting-pool.service';
import { MediaManagerDomainModel } from '../domainModels/media-manager/media-manager-domain-model';
import { MediaManagerStore } from '../domainModels/media-manager/store';
import { MediaManagerRemoteAssetSyncService } from '../domainModels/media-manager/sync/media-manager-remote-asset-sync.service';
import { MediaManagerRemoteFolderSyncService } from '../domainModels/media-manager/sync/media-manager-remote-folder-sync.service';
import { MediaManagerUploadService } from '../domainModels/media-manager/upload/media-manager-upload.service';
import { MediaManagerFolderService } from '../domainModels/media-manager/folder/media-manager-folder.service';
import { MediaManagerAssetService } from '../domainModels/media-manager/asset/media-manager-asset.service';
import { MediaManagerBulkDeleteService } from '../domainModels/media-manager/bulk-delete/media-manager-bulk-delete.service';
import { AssetRepository } from '../repositories/asset/asset-repository';
import { BadgeMappingRepository } from '../repositories/badge-mapping/badge-mapping-repository';
import { BadgeRepository } from '../repositories/badge/badge-repository';
import { BulkPrintJobRepository } from '../repositories/bulk-print-job/bulk-print-job-repository';
import { CompanyRepository } from '../repositories/company/company-repository';
import { DeviceRepository } from '../repositories/device/device-repository';
import { DisplayRepository } from '../repositories/display/display-repository';
import { DisplayAttributesRepository } from '../repositories/display-attributes/display-attributes-repository';
import { FiltersRepository } from '../repositories/filters/filters-repository';
import { InsightsRepository } from '../repositories/insights/insights-repository';
import { LabelRepository } from '../repositories/label/label-repository';
import { LocationRepository } from '../repositories/location/location-repository';
import { MenuRepository } from '../repositories/menu/menu-repository';
import { ProductRepository } from '../repositories/product/product-repository';
import { ProductTagRepository } from '../repositories/product-tag/product-tag-repository';
import { ScheduledMenuRepository } from '../repositories/scheduled-menu/scheduled-menu-repository';
import { SyncRepository } from '../repositories/sync/sync-repository';
import { SectionBlueprintRepository } from '../repositories/section-blueprint/section-blueprint-repository';
import { SmartFiltersRepository } from '../repositories/smart-filters/smart-filters-repository';
import { TemplateRepository } from '../repositories/template/template-repository';
import { TemplateCollectionRepository } from '../repositories/template-collection/template-collection-repository';
import { TaxRepository } from '../repositories/tax/tax-repository';
import { ProductSignalsRepository } from '../repositories/product-signals/product-signals-repository';

export const apisGloballyScopedToLoginContext = [AutomationApi, DisplayApi, GuideApi, MenuApi, ProductApi, TemplateApi];

/**
 * Repositories sit between the domain models and the data sources they read from (`FileSystemService` for the local
 * OPFS cache, and the `*Api` classes for the server). Domain models reach data through a repository rather than
 * touching either one directly.
 */
export const repositoriesGloballyScopedToLoginContext = [
  AssetRepository,
  BadgeMappingRepository,
  BadgeRepository,
  BulkPrintJobRepository,
  CompanyRepository,
  DeviceRepository,
  DisplayAttributesRepository,
  DisplayRepository,
  FiltersRepository,
  InsightsRepository,
  LabelRepository,
  LocationRepository,
  MenuRepository,
  ProductRepository,
  ProductSignalsRepository,
  ProductTagRepository,
  ScheduledMenuRepository,
  SectionBlueprintRepository,
  SmartFiltersRepository,
  SyncRepository,
  TaxRepository,
  TemplateCollectionRepository,
  TemplateRepository
];

export const domainModelsGloballyScopedToLoginContext = [
  BadgeDomainModel,
  BulkPrintJobDomainModel,
  CompanyDomainModel,
  DeviceDomainModel,
  DisplayAttributesDomainModel,
  DisplayDomainModel,
  FiltersDomainModel,
  HelpDomainModel,
  HighGuideInsightsDomainModel,
  LabelDomainModel,
  LocationDomainModel,
  MenuDomainModel,
  PexelsDomainModel,
  ProductDomainModel,
  ProductSignalsDomainModel,
  ScheduledMenusDomainModel,
  SectionBlueprintsDomainModel,
  SmartFiltersDomainModel,
  SmartFiltersDomainModel,
  SyncDomainModel,
  TemplateDomainModel,
  TemplateCollectionDomainModel,
  CannabinoidsAndTerpenesDomainModel,
  ProductTagDomainModel,
  BadgeMappingDomainModel,
  MediaManagerStore,
  MediaManagerDomainModel,
  MediaManagerRemoteAssetSyncService,
  MediaManagerRemoteFolderSyncService,
  MediaManagerUploadService,
  MediaManagerFolderService,
  MediaManagerAssetService,
  MediaManagerBulkDeleteService
];

export const viewModelsGloballyScopedToLoginContext = [
  FilterProductsFormViewModel,
  AllProductsViewModel,
  AllProductsDataTableViewModel,
  DigitalMarketingMenusViewModel,
  OrderReceivingFilterFormViewModel,
  ProductPickerDataTableViewModel,
  ProductPickerViewModel,
  SmartFilterRowViewModel,
  OrderReceivingViewModel,
  ShowInventorySinceViewModel,
  SelectBulkChangePropertiesViewModel,
  AllDisplaysViewModel,
  DigitalMenusContainerViewModel,
  DigitalTemplatesContainerViewModel,
  PrintMenusContainerViewModel,
  PrintTemplatesContainerViewModel,
  WebMenusContainerViewModel,
  WebTemplatesContainerViewModel
];

export const servicesGloballyScopedToLoginContext = [
  AppOutOfDateService,
  AssetService,
  ChangesRequiredForPreviewService,
  DomainTunnelFromMenuToTemplateService,
  FileSystemService,
  HighGuideInsightsPlaceholderService,
  MenuDisplayableSubItemService,
  MenuPreviewService,
  PreviewWaitingPoolService,
  PrintCardPreviewService,
  PrintPDFService,
  RestrictedLocationMismatchService,
  SyncSmartFilterService,
  TypeService,
  WebSocketService,
  {
    provide: PrivateFileSystemService,
    useExisting: FileSystemService
  },
  {
    provide: PrivateFileSystemAssetService,
    useExisting: AssetService
  }
];
